<template>
  <div class="welcome-card shadow-sm mb-4 no-print">
    <!-- استخدام g-3 لإضافة مسافات ذكية بين الأعمدة -->
    <div class="row g-3 align-items-center">
      
      <!-- 1. الجزء الأيمن (الترحيب والبيانات) -->
      <div class="col-12 col-md-8">
        <!-- 
           flex-column: للموبايل (فوق بعض)
           flex-sm-row: للشاشات الأكبر (بجانب بعض)
        -->
        <div class="d-flex flex-column flex-sm-row align-items-center text-center text-sm-start">
          
          <!-- الأيقونة -->
          <div class="icon-box rounded-circle d-flex align-items-center justify-content-center mb-2 mb-sm-0 ms-sm-3 flex-shrink-0" :class="roleColorClass">
            <i :class="roleIcon" class="fs-4 text-white"></i>
          </div>
          
          <!-- النصوص -->
          <div>
            <h5 class="fw-bold mb-1 text-dark">
              {{ greeting }}، <span class="text-primary">{{ user.name }}</span>
            </h5>
            <p class="mb-0 text-muted small d-flex align-items-center justify-content-center justify-content-sm-start flex-wrap gap-2">
              <span class="badge bg-light text-secondary border">
                <i class="fas fa-id-badge ms-1"></i> {{ roleText }}
              </span>
              <span v-if="entityName" class="fw-bold text-dark">
                 {{ entityName }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <!-- 2. الجزء الأيسر (التاريخ والوقت) -->
      <div class="col-12 col-md-4">
        <!-- 
           border-top: خط فاصل علوي للموبايل
           border-md-top-0: إلغاء الخط العلوي في الكمبيوتر
           border-md-start: خط فاصل جانبي في الكمبيوتر (يمين في RTL)
        -->
        <div class="date-box pt-3 pt-md-0 mt-2 mt-md-0 border-top border-md-top-0 custom-border-md text-center text-md-start">
          <div class="d-inline-block text-center">
             <p class="mb-1 fw-bold text-secondary fs-6">
                <i class="far fa-calendar-alt ms-1 text-gold"></i> {{ currentDate }}
              </p>
              <p class="mb-0">
                <span class="badge bg-primary-subtle text-primary border border-primary-subtle px-3">
                  {{ currentHijriDate }}
                </span>
              </p>
          </div>
        </div>
      </div>

    </div>
    
    <!-- زخرفة خلفية -->
    <div class="bg-pattern"></div>
  </div>
</template>

<script>
export default {
  name: "UserWelcome",
  props: {
    user: { type: String, default: "المستخدم" },
    userRole: { type: String, default: "admin" }, 
    entityName: { type: String, default: "" }, 
  },
  data() {
    return {
      currentDate: "",
      currentHijriDate: "" 
    };
  },
  computed: {
    greeting() {
      const hour = new Date().getHours();
      return hour < 12 ? "صباح الخير" : "مساء الخير";
    },
    roleIcon() {
      switch (this.userRole) {
        case 'school': return 'fas fa-school';
        case 'usercontrol': return 'fas fa-user-tie'; 
        case 'admin': return 'fas fa-user-shield';
        default: return 'fas fa-user';
      }
    },
    roleColorClass() {
      switch (this.userRole) {
        case 'school': return 'bg-success';
        case 'usercontrol': return 'bg-primary'; 
        case 'admin': return 'bg-danger';
        default: return 'bg-secondary';
      }
    },
    roleText() {
      switch (this.userRole) {
        case 'school': return 'مدير المدرسة';
        case 'usercontrol': return 'رئيس اللجنة';
        case 'admin': return 'مسؤول النظام';
        default: return 'مستخدم';
      }
    }
  },
  mounted() {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    this.currentDate = new Date().toLocaleDateString('ar-EG', options);
    this.currentHijriDate = new Intl.DateTimeFormat('ar-SA-u-ca-islamic', {
        day: 'numeric', month: 'long', year: 'numeric'
    }).format(Date.now());
  }
};
</script>

<style scoped>
.welcome-card {
  background: #fff;
  border-radius: 12px; /* حواف أكثر دائرية */
  padding: 1.25rem;
  position: relative;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  border-right: 5px solid; 
  border-right-color: #0d47a1; 
  transition: transform 0.2s;
}

/* ألوان الحدود الجانبية */
.welcome-card:has(.bg-success) { border-right-color: #198754; }
.welcome-card:has(.bg-primary) { border-right-color: #0d6efd; }
.welcome-card:has(.bg-danger) { border-right-color: #dc3545; }

.icon-box {
  width: 45px;
  height: 45px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.text-gold { color: #ffc107; }

/* تنسيق الحدود المتجاوب (Custom Media Query for Borders) */
/* في الشاشات الكبيرة (لابتوب) */
@media (min-width: 768px) {
  .custom-border-md {
    border-top: none !important;
    border-right: 1px solid #eee; /* فاصل جانبي */
    padding-right: 20px; /* مسافة عن الفاصل */
  }
  
  /* محاذاة النص لليمين في الشاشات الكبيرة */
  .text-sm-start {
      text-align: right !important; /* لأننا RTL */
  }
}

/* الخلفية الزخرفية */
.bg-pattern {
  position: absolute;
  top: -20px;
  left: -20px;
  width: 150px;
  height: 150px;
  background-image: radial-gradient(#e9ecef 2px, transparent 2px);
  background-size: 15px 15px;
  opacity: 0.6;
  z-index: 0;
  pointer-events: none;
}
</style>